<script lang="ts" setup>
import { VSegmentedControl, SegmentOption } from "@app/core";
import { computed } from "vue";

import { useGlobalFiltersSync } from "@/shared/composables/useGlobalFiltersSync";
import type { GranularityValue } from "@/shared/config/globalFilters.config";
import { useGlobalFiltersStore } from "@/shared/stores/useGlobalFiltersStore";

const filtersStore = useGlobalFiltersStore();
const { updateGranularity } = useGlobalFiltersSync();

const allOptions: Record<GranularityValue, SegmentOption> = {
  MONTH: { label: "Month", value: "MONTH", icon: "lucide:calendar" },
  WEEK: { label: "Week", value: "WEEK", icon: "lucide:calendar-range" },
  DAY: { label: "Day", value: "DAY", icon: "lucide:calendar-days" },
};

const options = computed<SegmentOption[]>(() => {
  return filtersStore.allowedGranularityValues.map(value => allOptions[value]);
});

const selectedGranularity = computed({
  get: () => filtersStore.granularity,
  set: (value: string | number) => {
    filtersStore.setGranularity(value as "MONTH" | "WEEK" | "DAY");
    updateGranularity();
  },
});
</script>

<template>
  <VSegmentedControl
    v-model="selectedGranularity"
    :options="options"
    size="md"
  />
</template>
